import PageNotFound from '@/views/errors/404.vue'
import Unauthorized from '@/views/errors/403.vue'

export default [
  {
    path: '/403',
    component: Unauthorized,
    name: 'Unauthorized',
    meta: {
      error: true,
      requiresAuth: true,
      fail: '/404.html'
    }
  },
  {
    path: '*',
    component: PageNotFound,
    name: 'Page not found',
    meta: {
      error: true,
      requiresAuth: true,
      fail: '/404.html'
    }
  }
]
